import React from 'react';
import { useNavigate } from 'react-router';
import MagicButton from 'components/MagicButton/MagicButton';
import './SharedCollection.css';

const UserNotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBrowseUsers = () => {
    navigate('/welcome');
  };

  return (
    <div className="shared-collection-error">
      <div className="error-content">
        <div className="error-icon">🔍</div>
        <h1 className="error-title">User Not Found</h1>
        <p className="error-message">
          We couldn't find a user with this username.
        </p>
        <div className="error-action">
          <MagicButton
            label="Browse All Users"
            color="purple"
            onPress={handleBrowseUsers}
          />
        </div>
      </div>
    </div>
  );
};

export default UserNotFoundPage;
